import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import AnimatedHeading from 'components/animated-heading-otros'

class Sitelock extends React.Component {

    shouldComponentUpdate() {
        return false
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 20px 0 30px 0;
            .heading {
                width: 100%;
            }                    
        `

        const ServiceRow = styled(Row)`
            margin-top: 150px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #0174c3 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `
        const ServiceHeading3 = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #f3000b !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const Heading2 = styled.h2`
            font-size: 38px;
            font-weight: 500;
            font-family: Oswald;
            color: #c1eb18;
            margin: 70px 0 10px 0;
            @media (max-width: 767px) {
                margin: 50px 0 20px 0;
                font-size: 30px;
                line-height: 40px;           
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 5px;
        `        

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #c1eb18;
            font-weight: 900;
            top: -80px;
            opacity: .2;
            margin-bottom: 20px;
            transition: .2s;
        `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .4 !important;
                color: #c1eb18;
            }
        `

        const ServiceText = styled.p`
            font-size: 17px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #fff;            
        `        

        const Color1 = styled.span`            
            color: #c1eb18;            
        `

        const Element = styled.div`
              margin-bottom: 20px;
              text-align: center;
              img {
                max-height: 500px;
                max-width: 500px;
                width: 100%;
                height: auto;
              }
              transition: 0.2s;
              &:hover {
                transform: translateY(-10px);
              }
              @media (max-width: 767px) {
                width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
                padding: 0;
                margin: 40px 0;            
                img {
                  max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
                  width: 100vw;        /* Igual que el viewport */
                  height: auto;
                  display: block;       /* Asegura que no tenga espacio extra por inline */          
                }        
              }
            `        


        return(
            <Section>
                <Container>
                    <AnimatedHeading text="Certificado email" />
                    <Row>
                        <Col md={12}>
                            
                                <Heading2>
                                    Funcionamiento de Sectigo SMIME Email & Document
                                </Heading2>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            
                                <Text>
                                    Cuando un usuario utiliza Sectigo SMIME Email & Document para enviar un correo electrónico, el contenido se cifra utilizando algoritmos de cifrado
                                    robustos. Además, se agrega una firma digital al mensaje para garantizar su autenticidad y verificar que no ha sido alterado durante la transmisión.
                                    El destinatario del correo electrónico puede verificar la firma digital y descifrar el contenido utilizando su clave privada correspondiente,
                                    garantizando así la confidencialidad e integridad de la comunicación.
                                </Text>
                                <Heading2>
                                    Protege tus documentos Electrónicos con Sectigo S/MIME
                                </Heading2>
                                <Text>
                                    Firmar documentos electrónicos con certificados S/MIME de Sectigo es una forma segura y eficaz de garantizar la autenticidad y la integridad de tus
                                    documentos en el entorno digital. Ya sea para transacciones comerciales, comunicaciones legales o simplemente para mantener la seguridad de la
                                    información, Sectigo S/MIME Email & Document ofrece una solución confiable para todas tus necesidades de firma digital. Asegura la confianza y la
                                    seguridad en tus documentos electrónicos con Sectigo S/MIME.
                                </Text>
                            
                        </Col>
                        <Col md={6}>
                            
                                <Element>
                                    <GatsbyImage image={this.props.image} alt="Correos electrónicos Certificados" sizes="(max-width: 767px) 300px, 500px" />
                                </Element>
                            
                        </Col>
                    </Row>
                    <ServiceRow>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        <Color1>Encriptado</Color1>
                                    </ServiceNumber>
                                    <ServiceHeading3>
                                        Correo electrónico seguro
                                    </ServiceHeading3>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Obtenga un cifrado sólido de extremo a extremo entre usted y sus contactos utilizando Sectigo SMIME. El certificado garantiza que el correo nunca
                                        pueda ser interceptado ni descifrado por atacantes MIM (Man-In-The-Middle), servidores proxy https o rastreadores de paquetes. Los clientes
                                        compatibles incluyen Windows Live Mail, Apple Mail, IOS, Eudora, Mozilla Thunderbird, Microsoft Outlook 2003/2007/2010/2013, Android y más.
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        <Color1>Seguridad</Color1>
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        Autenticación de dos factores
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Los certificados SMIME de Sectigo permiten a las empresas reducir el riesgo de amenazas mediante la autenticación de dos factores estándar del banco de
                                        empleados y clientes. Los productos SMIME son muy utilizados por empresas de todos los tamaños,  para garantizar que la persona que accede a una cuenta
                                        en línea, se autentique correctamente y no sea un atacante o pirata informático que intente robar el nombre de usuario o la contraseña. La
                                        autenticación de un solo factor no es suficiente para proteger la información confidencial y privada.
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        Firma
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        Firma de documentos
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Los certificados SMIME permiten firmar cualquier documento personal o empresarial para confirmar la identidad del firmante. Esto ayuda a dejar de utilizar
                                        flujos de trabajo basados en tinta y papel en elementos como contratos, firmas de documentos o formularios de solicitud internos. Admite los principales
                                        software empresariales, incluidos Open Office Suite, Microsoft Office Suite, VBA Macros y más.
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
      query={graphql`
        {
          file(relativePath: { eq: "certificado-email.webp" }) {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: DOMINANT_COLOR
                quality: 80
                formats: [AUTO, WEBP, AVIF]
                width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return <Sitelock image={image} {...props} />;
      }}
    />
  );
  
  export default Iconos;
